import {createAction, props} from '@ngrx/store';
import {PaginatedMailerDomain} from '@app/modules/shared/models';

enum EMailerDomainActions {
  MailerDomainsList = '[MailerDomains] Mailer Domains List',
  MailerDomainsListSuccess = '[MailerDomains] Mailer Domains List Success',
  MailerDomainsListError = '[MailerDomains] Mailer Domains List Error',
  MailerDomainDelete = '[MailerDomains] Mailer Domain Delete',
  MailerDomainDeleteSuccess = '[MailerDomains] Mailer Domain Delete Success',
  MailerDomainDeleteError = '[MailerDomains] Mailer Domain Delete Error',
  MailerDomainCreate = '[MailerDomains] Mailer Domain Create',
  MailerDomainCreateSuccess = '[MailerDomains] Mailer Domain Create Success',
  MailerDomainCreateError = '[MailerDomains] Mailer Domain Create Error',
  MailerDomainUpdate = '[MailerDomains] Mailer Domain Update',
  MailerDomainUpdateSuccess = '[MailerDomains] Mailer Domain Update Success',
  MailerDomainUpdateError = '[MailerDomains] Mailer Domain Update Error',
  ResetMailerDomainState = '[MailerDomains] Reset Mailer Domain State',
}

export const MailerDomainsList = createAction(EMailerDomainActions.MailerDomainsList, (params: any = {}) => params);
export const MailerDomainsListSuccess = createAction(EMailerDomainActions.MailerDomainsListSuccess, props<{ paginatedMailerDomains: PaginatedMailerDomain }>());
export const MailerDomainsListError = createAction(EMailerDomainActions.MailerDomainsListError, props<{ error: string }>());

export const MailerDomainDelete = createAction(EMailerDomainActions.MailerDomainDelete, props<{ mailerDomainId: string }>());
export const MailerDomainDeleteSuccess = createAction(EMailerDomainActions.MailerDomainDeleteSuccess);
export const MailerDomainDeleteError = createAction(EMailerDomainActions.MailerDomainDeleteError, props<{ error: string }>());

export const MailerDomainCreate = createAction(EMailerDomainActions.MailerDomainCreate, props<{ mailerDomain: any }>());
export const MailerDomainCreateSuccess = createAction(EMailerDomainActions.MailerDomainCreateSuccess);
export const MailerDomainCreateError = createAction(EMailerDomainActions.MailerDomainCreateError, props<{ error: string }>());

export const MailerDomainUpdate = createAction(EMailerDomainActions.MailerDomainUpdate, props<{ mailerDomainId: string; mailerDomain: any }>());
export const MailerDomainUpdateSuccess = createAction(EMailerDomainActions.MailerDomainUpdateSuccess);
export const MailerDomainUpdateError = createAction(EMailerDomainActions.MailerDomainUpdateError, props<{ error: string }>());

export const ResetMailerDomainState = createAction(EMailerDomainActions.ResetMailerDomainState, (params: any = {}) => params);
